





























import {
  computed,
  defineComponent,
  ref,
} from '@vue/composition-api';
import * as styles from '@fc/angie-ui/dist/styles/_js_exports.scss';
import { isMobileEffect, isTabletUpEffect } from '~/effects/matchMedia';
import { ICarouselAttrs, CarouselMode } from './types';

export default defineComponent({
  name: 'StoryblokCarousel',
  inheritAttrs: false,
  setup(_, context) {
    const swiperContainerRef = ref<any>(null);
    const isMobile = isMobileEffect();
    const isDesktop = isTabletUpEffect();

    const {
      label,
      slides,
      activeMobile,
      activeDesktop,
      mode,
      hideNavigation,
      displayArrowNavigation,
      staticHorizontalOffset,
      arrowColor,
    } = (context.attrs ?? {}) as ICarouselAttrs;

    const isThreeSlideView = computed(() => (mode === CarouselMode.threeSlideView));

    const carouselBindings = computed(() => ({
      screenLabel: label,
      infiniteSlidesEnabled: true,
      hideNavigation,
      displayArrowNavigation,
    }));

    const carouselActive = computed(() => (isMobile.value && activeMobile) || (isDesktop.value && activeDesktop));

    const slidesPerViewComputed = computed(() => {
      if (isThreeSlideView.value) {
        if (isDesktop.value) return 3;
        if (isMobile.value) return 1;

        return 1.5;
      }
      return 1;
    });

    const spaceBetweenComputed = computed(() => {
      if (isThreeSlideView.value) {
        if (isMobile.value) {
          return 10;
        }
        return 16;
      }
      return 16;
    });

    const arrowStylesComputed = computed(() => ({
      '--swiper-navigation-color': styles[arrowColor] || styles.lightgray,
      '--swiper-navigation-sides-offset': '0px',
      '--swiper-navigation-size': isMobile.value ? '23px' : '40px',
    }));

    const onSwiperInit = () => {
      // console.log('Swiper initialized', e.detail[0]);
      // You can access swiper instance here if needed: swiperContainerRef.value = e.detail[0];
    };

    const onSwiperSlideChange = () => {
      // const [swiperInstance] = e.detail;
      // console.log('Swiper slide changed to index', swiperInstance.activeIndex);
    };

    const swiperWrapperClasses = computed(() => [
      (staticHorizontalOffset ?? '').length && !isThreeSlideView.value ? 'overflow-effect' : '', // Keep overflow for non-3-slide with offset
    ]);

    return {
      swiperContainerRef,
      swiperWrapperClasses,
      carouselActive,
      slides,
      isThreeSlideView,
      carouselBindings, // Contains screenLabel, infiniteSlidesEnabled, etc.
      slidesPerViewComputed,
      spaceBetweenComputed,
      arrowStylesComputed,
      onSwiperInit,
      onSwiperSlideChange,
    };
  },
});
